import type { GcpSmComponents } from "@p0security/integrations-gcp-sm-shared/components";
import { integrationOptionProvider } from "@p0security/integrations-installer";
import type { FrontendInstaller } from "@p0security/integrations-installer";

export const gcpSmInstaller: FrontendInstaller<typeof GcpSmComponents> = {
  components: {
    "iam-write": {
      optionProvider: integrationOptionProvider("iam-write", [
        { component: "iam-write", integration: "gcloud" },
      ]),
    },
  },
};
